import React from 'react';
import logoFullColorMedium from '../assets/logo-full-color-medium.png';

/**
 * 
 * @param {*} props 
 * @returns 
 */
const Logo = props => {
  const logoContainerStyle = {
    paddingTop: 20,
    ...props.customLogoContainerStyle
  };
  const logoStyle = {
    display: 'block',
    margin: '0 auto 10px',
    maxHeight: '220px',
    maxWidth: '350px',
    paddingBottom: '25px',
    paddingTop: '35px',
    ...props.customStyle
  };
  return /*#__PURE__*/React.createElement("div", {
    style: logoContainerStyle
  }, /*#__PURE__*/React.createElement("img", {
    alt: `${props.whitelabel.name || 'Simply Benefits'} Logo`,
    src: props.whitelabel.logo || logoFullColorMedium,
    style: logoStyle
  }));
};
export default Logo;